import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, withCtx as _withCtx, createSlots as _createSlots, createBlock as _createBlock, renderSlot as _renderSlot, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "base-tabs" }
const _hoisted_2 = { class: "header" }
const _hoisted_3 = ["onClick"]
const _hoisted_4 = { class: "icon" }
const _hoisted_5 = { class: "label" }
const _hoisted_6 = {
  key: 0,
  class: "title"
}
const _hoisted_7 = { class: "content" }

import { computed, ref } from "vue";
import { useRouter } from "vue-router";
import { svgIcon, baseTooltip } from "@/common/components";

interface TabType {
  icon: string;
  url?: string;
  label?: string;
  key?: string;
}


export default /*@__PURE__*/_defineComponent({
  __name: 'tab-menu',
  props: {
    tabs: {},
    active: { default: null }
  },
  emits: ["select:tab"],
  setup(__props: any, { emit: __emit }) {

const router = useRouter();

const emit = __emit;

const props = __props;

const tabActive = computed(() =>
  props.tabs.findIndex((item) => item.key === props.active)
);

function selectTab(data: TabType) {
  if (data.url) router.push(data.url);

  if (data.key) emit("select:tab", data.key);
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.tabs, (tab, index) => {
        return (_openBlock(), _createBlock(_unref(baseTooltip), { key: index }, _createSlots({
          trigger: _withCtx(() => [
            _createElementVNode("div", {
              class: _normalizeClass(["tab", { active: tabActive.value === index }]),
              onClick: ($event: any) => (selectTab(tab))
            }, [
              _createElementVNode("div", _hoisted_4, [
                _createVNode(_unref(svgIcon), {
                  icon: tab.icon,
                  size: "2rem"
                }, null, 8, ["icon"])
              ])
            ], 10, _hoisted_3)
          ]),
          _: 2
        }, [
          (tab.label)
            ? {
                name: "tooltip",
                fn: _withCtx(() => [
                  _createElementVNode("div", _hoisted_5, _toDisplayString(tab.label), 1)
                ]),
                key: "0"
              }
            : undefined
        ]), 1024))
      }), 128))
    ]),
    (_ctx.$slots.title)
      ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
          _renderSlot(_ctx.$slots, "title")
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_7, [
      _renderSlot(_ctx.$slots, "content")
    ])
  ]))
}
}

})